export const getHmac = () => {
  const searchParams = new URLSearchParams(location.search);

  return searchParams.get('hmac');
};

export const hasHmac = (): boolean => !!getHmac();
